import { useState } from 'react';
import { Link } from 'react-router-dom';
import { CompanyBrandingSection } from './CompanyBrandingSection';
import { TimeZoneSection } from './TimeZoneSection';
import { SOL_MEMORY_PATH } from '../sol/sol-routes';
import './settings.css';

/**
 * SETTINGS — M10 / S10-03A.
 *
 * **THE SMALLEST SURFACE THAT CAN OWN COMPANY BRANDING, AND NOTHING MORE.**
 * Crewlink had no Settings at all; the roadmap places a general one in M12 with
 * the timezone picker. This slice pulls forward only what branding needs, so a
 * future slice adds a section here rather than inventing the screen.
 *
 * **AND THAT IS EXACTLY WHAT M12 / S12-00 DID:** the time zone arrived as one
 * more section, with no change to the screen around it.
 *
 * **WHY BRANDING IS NOT IN THE REPORT BUILDER.** Brandon configures his
 * business once. Making him confirm his company name and logo on every report
 * would be the friction this milestone exists to remove — so Generate Report
 * READS this and never edits it.
 *
 * **THE KEY FORCES A FRESH FORM WHEN THE SAVED PROFILE CHANGES.** Without it,
 * a save would leave the fields showing what he typed rather than what the
 * server accepted — indistinguishable on screen, and wrong the moment the two
 * differ.
 */
export function SettingsScreen() {
  // Bumped after each successful save so the branding form re-reads and
  // re-mounts from server truth.
  const [savedGeneration, setSavedGeneration] = useState(0);

  return (
    <main className="cl-screen settings-screen">
      <p className="settings-back project-home-back">
        <Link className="cl-link" to="/">
          ‹ Projects
        </Link>
      </p>

      <h1 className="cl-screen-title">Settings</h1>

      <CompanyBrandingSection
        key={savedGeneration}
        onSaved={() => {
          setSavedGeneration((current) => current + 1);
        }}
      />

      {/* TIME ZONE (M12 / S12-00). Crewlink's canonical timezone, and the only
          place it may be changed — a device that travels never moves it. It
          owns its own read and its own save, so a branding save cannot disturb
          it and it cannot disturb branding. */}
      <TimeZoneSection />

      {/* SOL MEMORY (M11 / D-040). A link, not a section: what Sol remembers
          is its own screen with its own controls, and it is Project-independent
          like everything else here. */}
      <section className="settings-section" aria-labelledby="settings-sol-memory-heading">
        <h2 id="settings-sol-memory-heading">Sol memory</h2>
        <p className="settings-lead">
          See, correct or forget the preferences and instructions Sol keeps for you.
        </p>
        <p className="settings-logo-actions">
          <Link className="cl-button cl-button--quiet" to={SOL_MEMORY_PATH}>
            Open Sol memory
          </Link>
        </p>
      </section>
    </main>
  );
}
